/** Shared by loaded screens and their loading placeholders. */
export const TABLE_COLUMN_WIDTH = 1180;
export const READING_COLUMN_WIDTH = 980;
export function columnWidth(wide?: boolean | "table" | "record"): number {
  if (wide === "record") return 1280;
  if (wide === "table") return TABLE_COLUMN_WIDTH;
  return wide ? READING_COLUMN_WIDTH : 900;
}
export const ITEM_DETAIL_COLUMNS = "minmax(0,1fr) minmax(0,1.15fr)";
export const WALK_COLUMNS = "repeat(auto-fit, minmax(min(100%, 340px), 1fr))";
export const PHOTO_TILE_MIN = 168;
/** Center the initial 62px Home composer 40% down the viewport. The header
 * sits above it, accounting for the mobile navigation bar. */
export const HOME_TOP = "max(0px, calc(40svh - 31px - var(--home-pane-top, 0px)))";
export const TEAM_PAGE = {
  width: "100%", maxWidth: 1080, margin: "0 auto", boxSizing: "border-box" as const,
  padding: "36px 32px 0", display: "flex", flexDirection: "column" as const, gap: 16,
};

/**
 * The records table — Punch, Observations, Autodesk Issues
 * (`views/records/RecordsWorkspace.tsx`) — and its loading skeleton. Both are
 * full-bleed: a top bar, a filter bar, then a table whose viewport ends where
 * the Ask composer's rail begins (the clearance minus the rail's 60px of
 * headroom), so its sticky totals row rests on the rail instead of under it.
 */
export const RECORDS_TOP_BAR = { height: 52, padding: "0 16px" } as const;
export const RECORDS_FILTER_BAR = { minHeight: 48, padding: "9px 16px" } as const;
export const RECORDS_TABLE_END = "calc(var(--ask-composer-clearance, 208px) - 60px)";
export const RECORDS_HEADER_ROW = 40;
export const RECORDS_ROW = 44;
/**
 * Below this width the top bar's title, view pills, Export and "New
 * observation" do not fit on one line (390px: New ran 55px off the screen and
 * the pills were squeezed to nothing). Export and New become 32px icon
 * buttons there, in the loaded bar and in its skeleton alike.
 */
export const RECORDS_COMPACT_QUERY = "(max-width: 600px)";
export const RECORDS_ICON_BUTTON = 32;
